import { ENVIRONMENT_CONFIGS } from '../constants/environment-configs';
import { Environment } from '../enums/environment';

const setUpEnvironmentConfig = (environment: Environment): void => {
    const redirectURI: string = `${window.location.protocol}//${window.location.hostname}${
        window.location.port ? ':' + window.location.port : ''
    }`;

    const envData = {
        VITE_MSAL_REDIRECT_URI: redirectURI,
        VITE_MSAL_POSTLOGOUT_REDIRECT_URI: redirectURI
    };

    window.env = { ...envData, ...ENVIRONMENT_CONFIGS[environment] };
};

export { setUpEnvironmentConfig };
